import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

const SEO = ({
  title,
  description,
  keywords,
  image = '/src/assets/al-konda-logo-optimized.webp',
  url,
  type = 'website'
}) => {
  const { i18n } = useTranslation()
  const lang = i18n.language || 'en'
  const baseUrl = 'https://alkondagroup.com'
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl

  return (
    <Helmet>
      <html lang={lang} dir={lang === 'ar' || lang === 'ku' ? 'rtl' : 'ltr'} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${baseUrl}${image}`} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:locale" content={lang} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${baseUrl}${image}`} />

      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  )
}

export default SEO
